import { forwardRef, ForwardRefRenderFunction, PropsWithChildren } from 'react';
import { Slot, Slottable } from '@radix-ui/react-slot';
import { IconButton } from '../../../core-components';
import { wrapSlottableChildren } from '../../../utils';
type VideoComponentProps = PropsWithChildren<{
  asChild?: boolean;
}>;
const VideoComponentRenderFunction: ForwardRefRenderFunction<HTMLDivElement, VideoComponentProps> = (props, ref?) => {
  const {
    children,
    asChild,
    ...rest
  } = props;
  const Element = asChild ? Slot : 'div';
  return <Element {...rest} ref={ref} className="group/icon-button relative block overflow-hidden rounded-sm" data-sentry-element="Element" data-sentry-component="VideoComponentRenderFunction" data-sentry-source-file="VideoComponent.tsx">
      <Slottable data-sentry-element="Slottable" data-sentry-source-file="VideoComponent.tsx">
        {wrapSlottableChildren(asChild, children, children => <div className="overlay-black/20">{children}</div>)}
      </Slottable>

      <IconButton asChild iconName="play" size="md" variant="primary" on="image" className="absolute left-1/2 top-1/2 -translate-x-1/2 -translate-y-1/2" data-sentry-element="IconButton" data-sentry-source-file="VideoComponent.tsx">
        <div />
      </IconButton>
    </Element>;
};
export const VideoComponent = forwardRef<HTMLDivElement, VideoComponentProps>(VideoComponentRenderFunction);